export default "__VITE_ASSET__D7zcMn8G__"